<template>
    <Modal @modal:dismiss="$emit('dismiss')">
        <h3 slot="header">{{ value.id ? 'Modifier' : 'Créer' }} un thème</h3>

        <div slot="body">
            <div class="form-control">
                <label>
                    Nom du thème <b>(obligatoire)</b>
                    <InputUniqChecker
                        class="stretch"
                        required
                        placeholder="Renseignez un nom de thème"
                        v-model="value.name"
                        :err-msg="`Un thème nommé ${value.name} existe déjà`"
                        url="/api/check/theme/name"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Groupes d'objets
                    <CustomSelect
                        class="stretch"
                        placeholder="Sélectionnez les groupes d'objets"
                        :options="objects"
                        :multiple="true"
                        v-model="value.objects"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Icône
                    <CustomIcon v-model="value.icon" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Couleur
                    <CustomColor v-model="value.color" />
                </label>
            </div>
        </div>

        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch" @click="$emit('dismiss')">Annuler</CustomButton>
                <CustomButton class="default stretch" @click="$emit('close')">
                    Enregistrer
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from './../Modal';
import InputUniqChecker from '@/components/InputUniqChecker';
import CustomButton from './../Button';
import CustomSelect from './../Select';
import CustomColor from './../SelectColor';
import CustomIcon from './../SelectIcon';

export default {
    props: ['value'],
    data() {
        return {
            objects: [],
        };
    },
    mounted() {
        this.$http.get('/api/object-group?scope=withoutTheme').then(
            (response) => {
                this.objects = []
                    .concat(
                        this.value.objects,
                        response.body.map((o) => ({
                            id: o.id,
                            text: o.name,
                        })),
                    )
                    .sort((a, b) => {
                        if (a.text < b.text) {
                            return -1;
                        }
                        if (a.text > b.text) {
                            return 1;
                        }
                        return 0;
                    });
            },
            (err) => {
                // error callback
                console.log(JSON.stringify(err));
            },
        );
    },
    components: {
        Modal,
        InputUniqChecker,
        CustomButton,
        CustomSelect,
        CustomColor,
        CustomIcon,
    },
};
</script>

<style lang="scss"></style>
